module.exports = __webpack_public_path__ + "img/lockerApp_ico_180.4fee59bf.png";